import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

/** Small stat tile: label on top, big value below */
const StatCard = ({ label, value, icon, color = 'primary.main' }) => (
  <Card sx={{ flex: 1, minWidth: 0 }}>
    <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.5 }}>
        {icon && <Box sx={{ color, display: 'flex', '& svg': { fontSize: 18 } }}>{icon}</Box>}
        <Typography variant="caption" color="text.secondary" noWrap sx={{ fontWeight: 600 }}>
          {label}
        </Typography>
      </Box>
      <Typography
        sx={{
          fontWeight: 800,
          letterSpacing: '-0.02em',
          lineHeight: 1.2,
          fontSize: 'clamp(0.85rem, 4vw, 1.2rem)',
          wordBreak: 'keep-all',
        }}
      >
        {value}
      </Typography>
    </CardContent>
  </Card>
);

export default StatCard;
